$(document).ready(() => {
    const heroSlider = $('.hero-carousel-wrapper.slick-enabled');

    heroSlider.on('init', setSlideLabel);
    heroSlider.slick();
    heroSlider.on('afterChange', setSlideLabel);

    let slideControl = $('.hero-slide-control');

    slideControl.click(function (e){
        const play = $(this).find('.play');
        const stop = $(this).find('.stop');
        const textPlay = $(this).find('.slick-play-text');
        const textStop = $(this).find('.slick-pause-text');

        let target = $(e.target);

        if(target.hasClass('play')){
            heroSlider.slick('slickPlay')
            play.addClass('d-none');
            stop.removeClass('d-none');
            textPlay.addClass('d-none');
            textStop.removeClass('d-none');
        }else{
            heroSlider.slick('slickPause');
            play.removeClass('d-none');
            stop.addClass('d-none');
            textPlay.removeClass('d-none');
            textStop.addClass('d-none');
        }
    });

    function setSlideLabel() {
        setTimeout(() => {
            let buttons = $('.slick-dots button');
            buttons.each((key, value) => {
                value.setAttribute('aria-label', 'Slide ' + value.getAttribute('aria-label'));
                value.setAttribute('tabindex', 0);
            })
        }, 100)
    }

    let  herCarousel, bullets, bulletPos;

    herCarousel = $('.hero-carousel-wrapper');
    bullets = $('.hero-carousel-wrapper .slick-dots button');
    bulletPos = 0;

    bullets.each(function () {
        bulletPos += 1;
        $(this).attr('data-count', bulletPos);
    });

    herCarousel.on('keydown', function(e) {
        let target = $(e.target);
        let key = e.keyCode || e.charCode || e.which;
        if(target.closest('.slick-active')){
            let currIndex = $(this).find('.slick-active button').data('count');
            switch (key){
                case 39 :
                    bullets.eq(currIndex - 1).focus();
                    break;
                case 37 :
                    bullets.eq(currIndex - 1).focus();
                    break;
            }
        }
    });
})
